import axios from "axios";
import util from "../utils";
import store from "../store";

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000,
});

request.interceptors.request.use(
  async (config) => {
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
    };
    store.dispatch("setLoding", true);
    return config;
  },
  (error) => {
    store.dispatch("setLoding", false);
    Promise.reject(error);
  }
);
request.interceptors.response.use(
  async (response) => {
    store.dispatch("setLoding", false);
    return response.data;
  },
  (error) => {
    store.dispatch("setLoding", false);
    let data = error.response.data;
    util.toast(data.msg);
  }
);

export default request;
